import axios from '@/utils/request'
export default {
	states_all: ['newly', 'outed', 'finished'],
	// 2020-11-26
	findBySerialNo(params) {
		return axios.get('/rents/items/find-by-serial-no', params)
	},
	// 2020-11-26
	delete(id) {
		return axios.delete('/rents/items/' + id)
	},
	// 2020-11-26
	update(id, params) {
		return axios.put('/rents/items/' + id, params)
	},
	// 2020-11-26
	insertBatch(params) {
		return axios.post('/rents/items/insert-batch', params);
	},
	// 2020-11-26
	out(id, params) {
		return axios.put('/rents/items/' + id + '/out', params)
	},
	// 2020-11-26
	finish(id, params) {
		return axios.put('/rents/items/' + id + '/finish', params)
	},
	// 2021-07-27
	productLifeCycle(params) {
		return axios.get('/rents/items/product-life-cycle', params)
	},
	// 2020-11-26
	findById(id) {
		return axios.get('/rents/items/' + id);
	}
}

